import { f } from "./index743.mjs";
import { h } from "./index811.mjs";
import { t as d } from "./index809.mjs";
import { a as v } from "./index866.mjs";
import { h as u } from "./index853.mjs";
var m = f, n = h, p = d, c = v.indexOf, y = u, i = m([].push), j = function(s, o) {
  var e = p(s), t = 0, a = [], r;
  for (r in e)
    !n(y, r) && n(e, r) && i(a, r);
  for (; o.length > t; )
    n(e, r = o[t++]) && (~c(a, r) || i(a, r));
  return a;
};
export {
  j as o
};
